import React from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import FormHOC from './FormHOC'
import TermsOfUseCheckbox from '../components/TermsOfUseCheckbox'
import TermsAndConditionsCheckbox from '../components/TermsAndConditionsCheckbox'
import { SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS, mapServiceTypeToTitle } from '../constants'
import ComparePlans from '../components/ComparePlans/ComparePlans'
import CustomLink from '../components/CustomLink'
import globals from '../globals'
import BestPlanAvailable from '../components/BestPlanAvailable'

const options = {
    postUrl: '/api/postChangePlanMobile',
    success: 'Success! Your plan has been updated.'
}

const state = {
    serviceId: '',
    planId: null,
    planObj: {}, // For GA event
    termsOfUse: false,
    termsAndConditions: false
}

class MobilePlanForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    componentDidUpdate (prevProps) {
        if (prevProps.plans !== this.props.plans) {
		    this.selectPlanIfSingle()
        }
    }

    selectPlanIfSingle () {
        if (this.props.plans.length === 1 && this.props.plans[0]) {
            this.props.setDynamicValues({
                planId: this.props.plans[0].id,
                planObj: this.props.plans[0]
            })
        }
    }

    handleChangePlan (id, planObj) {
        this.props.setDynamicValues({
            planId: id,
            planObj: planObj
        })
    }

    mapExistingPlanFields () {
        return {
            title: this.props.serviceDetails.description,
            data: this.props.serviceDetails.includedData,
            price: this.props.serviceDetails.monthlyCharge,
            features: this.props.serviceDetails.features
        }
    }

    render () {
	    const BestPlan = () => {
	        if (this.props.type === SERVICE_MOBILE) {
	            return (
    <BestPlanAvailable
                        title='No plans available'
                        description='Exetel’s mobile plan change terms only allow you to switch to a higher value plan if you are still within your contract period. As you are currently on the highest value plan and still on-contract, there are no available plans for you to choose.'
                    />
                )
            }

	        return <BestPlanAvailable />
        }

        return (
            <div>
                {this.props.plans.length > 0
                    ? <React.Fragment>
                        <div className='row'>
                            <div className={`col-12 px-lg-4 ${this.props.type === SERVICE_WIRELESS ? 'col-lg-8 offset-lg-2' : 'col-lg-10 offset-lg-1'}`}>
                                <h2 className='text-center' dangerouslySetInnerHTML={{ __html: globals.noWidows(`Choose your new ${mapServiceTypeToTitle[this.props.type]} plan below:`) }} />
                                <ComparePlans
                                    type={this.props.type}
                                    plans={this.props.plans}
                                    existingPlan={this.mapExistingPlanFields()}
                                    handleSelect={this.handleChangePlan.bind(this)}
                                    selectedPlanId={parseInt(this.props.values.planId)}
                                />

                                <div className='row mt-2'>
                                    <div className='col-12 text-center mb-3'>
                                        <CustomLink to={this.props.cisUrl}><small>Critical information summary</small></CustomLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <TermsOfUseCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsOfUse}
                                    handleClick={value => this.props.setDynamicValues({ termsOfUse: value })}
                                    cisUrl={this.props.cisUrl}
                                    termsUrl={this.props.termsUrl}
                                />
                                <br />
                                <TermsAndConditionsCheckbox
                                    errors={this.props.errors}
                                    value={this.props.values.termsAndConditions}
                                    handleClick={value => this.props.setDynamicValues({ termsAndConditions: value })}
                                    type={this.props.type}
                                />
                                <br />
                                {this.props.children}
                            </div>
                        </div>
                        <div className='row my-4'>
                            <div className='col-12 col-md-4 offset-md-2 text-center text-md-left my-2'>
                                <Button title='Submit Change' action={this.props.handleSubmit} />
                            </div>
                            <div className='col-12 col-md-4 my-2 d-flex justify-content-center justify-content-md-end align-items-center'>
                                {this.props.type === 'mobile' ? <CustomLink to='https://www.exetel.com.au/mobilephone/charges' className='color-grey underline'>View Rate Card</CustomLink> : ''}
                            </div>
                        </div>
                      </React.Fragment>
                    : BestPlan()}
            </div>
        )
    }
}

MobilePlanForm.propTypes = {
    type: PropTypes.oneOf([SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS]),
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    cisUrl: PropTypes.string.isRequired,
    termsUrl: PropTypes.string.isRequired
}

export default FormHOC(MobilePlanForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/MobilePlanForm.js